import { Validator } from '@vista-digital/validator';
import { defaultMemberFilmWatchlistAssets, memberFilmWatchlistAssetsValidator } from './assets';
import { defaultMemberFilmWatchlistCdnOptions, memberFilmWatchlistCdnOptionsValidator } from './cdn-options';
import { defaultMemberFilmWatchlistConfig, memberFilmWatchlistConfigValidator } from './config';
import { defaultMemberFilmWatchlistDisplayText, memberFilmWatchlistDisplayTextValidator } from './display-text';
import { memberFilmWatchlistEventsValidator } from './events';
export const memberFilmWatchlistPropsValidator = Validator.object({
    config: memberFilmWatchlistConfigValidator,
    displayText: memberFilmWatchlistDisplayTextValidator,
    assets: memberFilmWatchlistAssetsValidator,
    events: memberFilmWatchlistEventsValidator,
    cdnOptions: memberFilmWatchlistCdnOptionsValidator
});
export const defaultMemberFilmWatchlistProps = {
    config: defaultMemberFilmWatchlistConfig,
    displayText: defaultMemberFilmWatchlistDisplayText,
    assets: defaultMemberFilmWatchlistAssets,
    events: {},
    cdnOptions: defaultMemberFilmWatchlistCdnOptions
};
